/**
 * Created by miguel on 22/2/17.
 */
/// <reference path="../base/MasterListViewController.ts" />
/// <reference path="../AppHelper.ts" />

class DocumentListViewController extends MasterListViewController
{    
    protected addButton:MUIButton = null;
	protected filterButton:MUIButton = null;
    
    viewDidLoad(){
        super.viewDidLoad();
		
        this.searchTextField = MUIOutlet( this, "search-bar", "MUITextField" );
        this.setupSearchTextField();
        
        this.addButton = MUIOutlet(this, "add-btn", "MUIButton");        

		this.filterButton = MUIOutlet(this, "filter-btn", "MUIButton");
		this.filterButton?.setAction(this, function() {
			AppHelper.sharedInstance().showFilterViewController(this, this.filters, this.filtersDidChange);
		});

        //trying a change in tableview to UItableView
        this.tableView = MUIOutlet(this, "tableview", "UITableView");
        this.tableView.dataSource = this;
        this.tableView.delegate = this;

        MIONotificationCenter.defaultCenter().addObserver(this, "DocumentWillDelete", this.itemDeletedNotification);
    }

    protected itemDeletedNotification( note:MIONotification) {
        if ( this.selectedItem != note.object ) return;
        this.selectedItem = null;
        let ip = this.fetchedResultsController.indexPathForObject(note.object);
        let cell = this.tableView.cellAtIndexPath(ip);
        if (cell != null) cell.selected = false;
        this.showNoItemSelected();
    }

    didSelectCellAtIndexPath(tableView:UITableView, indexPath:MIOIndexPath){
        let obj = this.fetchedResultsController.objectAtIndexPath(indexPath);
        this.selectedItem = obj;

        this.showSelectedItem();
    }

    protected showSelectedItem() { }
    protected showNoItemSelected() { }
	
    get entityName():string { return "DBDocument"; }
    get filters(){ return []; }

	protected _fetchedResultsController:MIOFetchedResultsController = null;
    set fetchedResultsController(value:MIOFetchedResultsController){
        if (value == null && this._fetchedResultsController != null)
            this._fetchedResultsController.delegate = null;
    
        this._fetchedResultsController = value;
    }
    
    get fetchedResultsController(){
        if (this._fetchedResultsController != null) return this._fetchedResultsController;
        return null;
    }
    
}